module.exports = __webpack_public_path__ + "img/ds-3.400b6671.png";